import { Injectable } from '@angular/core';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Helpers } from '@store';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import * as Api from '@vi-iot/client';

import { OperatingModesActions } from './operating-modes.actions';
import { OperatingModesStore } from './operating-modes.store';

@Injectable()
export class OperatingModesEffects {
  readOrListDeviceFeatures$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(OperatingModesActions.readOrListFeatures),
      concatLatestFrom(() => this.operatingModesStore.state$),
      map(([action, state]) => {
        if (state.installation && state.installation[action.installationId]) {
          return OperatingModesActions.listFeaturesSuccess({
            operatingModes: state.installation[action.installationId],
            gatewaySerial: action.gatewaySerial,
          });
        } else {
          return OperatingModesActions.listFeatures(action);
        }
      })
    );
  });

  listDeviceFeatures$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(OperatingModesActions.listFeatures),
      mergeMap((action) => {
        return this.api
          .listDeviceFeatures(
            action.installationId,
            action.gatewaySerial,
            action.pairingId,
            // request for only the features which map regex
            {
              regex:
                'heating.circuits.[0-9].operating.modes.active|' +
                'heating.configuration.multiFamilyHouse|' +
                'heating.device.time.offset|' +
                'heating.dhw.schedule|' +
                'heating.dhw.oneTimeCharge|' +
                'heating.dhw.operating.modes.active|' +
                '^heating.dhw$|' +
                '^heating.circuits$',
            }
          )
          .pipe(
            map((payload) => ({
              ...action,
              operatingModes: Helpers.extractOperatingModes(payload),
            })),
            map((payload) =>
              OperatingModesActions.listFeaturesSuccess({
                operatingModes: payload.operatingModes,
                gatewaySerial: action.gatewaySerial,
              })
            ),
            catchError(() => of(OperatingModesActions.listFeaturesError()))
          );
      })
    );
  });

  constructor(
    private api: Api.EquipmentApi,
    private actions$: Actions,
    private operatingModesStore: OperatingModesStore
  ) {}
}
